module.exports = __webpack_public_path__ + "img/6.962fce11.png";